import { useHostingOnboardingData } from '@newfold/huapi-js';

import useFilteredHostingSites from '~/hooks/useFilteredHostingSites';

const useMultiHostingOnboarding = (latestPlanHostingId: string) => {
  const { data: onboardingData, isPending } = useHostingOnboardingData(
    latestPlanHostingId,
    {
      query: {
        enabled: !!latestPlanHostingId,
        gcTime: 5000,
        staleTime: 5000,
      },
    },
  );

  const onboarding = onboardingData?.data;
  const hasOnboarding = typeof onboarding?.completed === 'boolean';
  const { data: hostingSites } = useFilteredHostingSites(
    latestPlanHostingId,
    { limit: 6, page: 1, search: '' },
    {
      query: {
        enabled: hasOnboarding && !!latestPlanHostingId,
      },
    },
  );
  const sites = hostingSites?.data?.items;
  const numberOfSites = hostingSites?.data?.items?.length;

  const firstSite = sites?.find(
    ({ type, docroot }) =>
      /*
        This will likely remain a reliable check for a while longer, but
        worth noting that this is making a pretty big assumption
      */
      type?.toLowerCase() === 'wordpress' && docroot === 'public_html',
  );

  return {
    onboarding,
    firstSiteId: firstSite?.id,
    firstSite,
    numberOfSites,
    isPending,
    hasOnboarding,
  };
};

export default useMultiHostingOnboarding;
